import axios from "axios";
import { getAPIUrl } from "../config";
import { formHeaderConfig, headerConfig } from "./authConfig";
import { clearLocalStorage } from "./userStorage";

const serviceEndPoint = `${getAPIUrl()}/api/site`;

const handleApiError = (error, showToast) => {
    const status = error.response?.status || "Network Error";
    const message = error.response?.data?.message || error.message;

    if (showToast) {
        showToast(message, "error"); 
    }
    setTimeout(() => {
        clearLocalStorage(); 
    }, 500);

    return { status, message };
};

export const getSiteData = async (showToast) => {
    try {
        const result = await axios.get(serviceEndPoint, headerConfig());

        if (result?.data?.success === false) {
            return handleApiError({
                response: { status: 401, data: { message: "Unauthorized access" } }
            }, showToast);
        }
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};
export const addSiteData = async (data, showToast) => {
    try {
        const result = await axios.post(serviceEndPoint, data, headerConfig());
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};

export const addMultiple = async (formData, showToast) => {
    try {
        const result = await axios.post(
            `${serviceEndPoint}/add-multiple`,
            formData,
            formHeaderConfig()
        );
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast );
    }
};

export const getSSLExpiringSites = async (days, showToast) => {
    try {
        const result = await axios.get(`${serviceEndPoint}/expiry/${days}`, headerConfig());
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};

export const getDomainExpiringSites = async (days, showToast) => {
    try {
        const result = await axios.get(`${serviceEndPoint}/domain-expiry/${days}`, headerConfig());
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};

export const getSitesByStatus = async (status, showToast) => {
    try {
        const result = await axios.get(`${serviceEndPoint}/status/${status}`, headerConfig());
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};

export const getSiteById = async (siteId, showToast) => {
    try {
        const result = await axios.get(`${serviceEndPoint}/${siteId}`, headerConfig());
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};
export const updateSiteData = async (data, showToast) => {
    try {
        const configData = headerConfig();
        const result = await axios.put(
            serviceEndPoint,
            {
                _id: data._id,
                id: data._id,
                name: data.name,
                link: data.link,
                status: data.status,
                sslExpiry: data.sslExpiry,
                domainExpiry: data.domainExpiry,
                phpVersion: data.phpVersion,
                wordPressVersion: data.wordPressVersion,
                active: data.active,
                comment: data.comment,
                contact: data.contact,
                runningStatus: data.runningStatus,
            },
            configData
        );
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};
export const deleteSite = async (id, showToast) => {
    try {
        const result = await axios.delete(`${serviceEndPoint}/${id}`, headerConfig());
        return result.data;
    } catch (error) {
        return handleApiError(error, showToast);
    }
};

export const detectSiteExpiry = async (url) => {
    try {
        const result = await axios.get(`${serviceEndPoint}/detect-expiry?url=${encodeURIComponent(url)}`, headerConfig());
        return result.data;
    } catch (error) {
        console.error("Error detecting expiry:", error);
        return { success: false, sslExpiry: null, domainExpiry: null };
    }
};
